import { makeAutoObservable, runInAction } from 'mobx';
import { AuthStore } from 'stores/users/AuthStore';
import { LoadStatus } from 'utils/types';
import { AccountNamesOutput } from 'dtos/accounts/AccountNamesOutput';
import { serverUri } from 'utils/config';
import { nullsToUndefined } from 'utils/nullsToUndefined';

export type AccountOption = {
  inputValue?: string;
  title: string;
};

export class AccountsStore {
  accountsStatus: LoadStatus = 'none';
  accounts?: AccountOption[];

  constructor(private readonly authStore: AuthStore) {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  async ensureAccountsLoaded() {
    if (this.accounts === undefined) {
      this.getAccounts();
    }
  }

  async getAccounts() {
    this.accountsStatus = 'loading';
    this.accounts = [];
    try {
      const response = await this.authStore.fetchWithAuth(`${serverUri}/accounts/names`, {
        method: 'GET',
      });
      if (!response.ok) throw new Error('Error getting accounts');
      const output: AccountNamesOutput = nullsToUndefined(await response.json());
      runInAction(() => {
        this.accountsStatus = 'success';
        this.accounts = output.names.map((title) => ({ title }));
      });
    } catch (err) {
      runInAction(() => {
        this.accountsStatus = 'error';
      });
    }
  }
}
